<template>
  <div class="pagination">
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pCurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pPageSize"
        :layout="getLayout"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
name: "pagination",
  props:{
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: Number,
  },
  data(){
    return {
      pCurrentPage: 1,
      pPageSize: 10
    }
  },
  created() {
  },
  computed:{
    getLayout(){
      return !this.$attrs.nosize ? "total, sizes, prev, pager, next" : "total, prev, pager, next"
    },
  },
  watch:{
    pageSize: {
      handler(val){
          return this.pPageSize = val
      },
      immediate: true
    },
    currentPage: {
      handler(val){
        return this.pCurrentPage = val
      },
      immediate: true
    },
  },
  methods:{
    handleSizeChange(val) {
      this.pCurrentPage = 1
      this.pPageSize = val
      this.$emit("getPageData", this.pCurrentPage, this.pPageSize)
    },
    handleCurrentChange(val) {
      this.pCurrentPage = val
      this.$emit("getPageData", this.pCurrentPage, this.pPageSize)
    },
  }
}
</script>

<style scoped lang="less">
  .pagination{
    margin: 8px 0 0 auto;
  }
</style>
<style lang="less">
@import "/src/style/variables";
.el-pagination{
  width: 100%;
  font-weight: 300 !important;
  color: rgba(0, 0, 0, 0.65) !important;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;
  .el-pagination__total{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.88);
  }
  .el-pagination__sizes{
    order: 10;
    margin-right: 0;
    .el-select .el-input{
      margin-right: 0 !important;
    }
  }
  .el-pagination__jump{
    order: 20;
  }

  .el-input--mini .el-input__inner{
    height: 32px;
    line-height: 32px;
  }
}
.el-pager{
  .active{
    background: white;
    border-radius: 6px;
    border: 1px solid @--color-primary;
  }
  li{
    border-radius: 6px !important;
    min-width: 28px;
    padding: 0 10px;
    background-color: unset;
  }
}
.btn-prev,.btn-next{
  border-radius: 6px !important;
}
.el-pagination .btn-prev, .el-pagination .btn-next, .el-pagination button:disabled{
  background-color: unset;
}
</style>